import { Spinner } from "@repo/ui/components/Base/Spinner";
import { DataTable } from "@repo/ui/components/Base/DataTable";
import { layoutDefaults, useColumns } from "./LetterheadTableColumns";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { ArchiveConfirmation } from "../dialog/ArchiveConfirmation";
import { useUserColumns } from "@/hooks/useUserColumns";
import { KEYS } from "@/lib/constants";
import { AppUrlPath } from "@/lib/AppUrlPath";
import { useTenantStore } from "@/stores/tenantStore";
import { letterHeadRepo } from "@/repositories/letterHeadRepo";
import { useLetterHeadList } from "@/hooks/queryHooks/letterHeadHooks";
import { LetterheadPreviewDialog } from "./LetterheadPreviewDialog";
import { useActiveTeam } from "@/hooks/useActiveTeam";

export const LetterHeadTable = ({ tenantId }: { tenantId: string }) => {
  const { data: letterHeads } = useLetterHeadList(tenantId);
  const tenant = useTenantStore((s) => s.tenant);
  const team = useActiveTeam() || undefined;

  const navigate = useNavigate();

  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [activeId, setActiveId] = useState("");
  const [archiveOpen, setArchiveOpen] = useState(false);

  const { defaultState, saveTableLayout, resetTableLayout } = useUserColumns(
    KEYS.LETTERHEAD_TABLE_COLUMNS,
    layoutDefaults
  );

  const handleEdit = (id: string) => {
    navigate(new AppUrlPath(tenantId).getLetterHeadPath(id));
  };

  const handlePreview = (id: string) => {
    setActiveId(id);
    setIsPreviewOpen(true);
  };

  const handleArchive = (docId: string) => {
    setActiveId(docId);
    setArchiveOpen(true);
  };

  return (
    <>
      {activeId && (
        <ArchiveConfirmation
          open={archiveOpen}
          setOpen={setArchiveOpen}
          itemId={activeId}
          onSubmit={async (letterHeadId) => {
            await letterHeadRepo.delete(tenantId, letterHeadId);
          }}
        />
      )}

      <LetterheadPreviewDialog
        open={isPreviewOpen}
        setOpen={setIsPreviewOpen}
        tenant={tenant}
        team={team}
        letterHead={letterHeads?.find((lh) => lh.id === activeId)}
      />

      {!letterHeads && <Spinner />}

      <DataTable
        columns={useColumns({
          handleEdit,
          handleView: handlePreview,
          handleArchive,
        })}
        data={letterHeads ?? []}
        userDefaults={defaultState}
        factoryDefaults={layoutDefaults}
        onLayoutSave={saveTableLayout}
        onLayoutReset={resetTableLayout}
      />
    </>
  );
};
